const canUseMediaSession = (navigatorRef = typeof navigator === 'undefined' ? null : navigator) => Boolean(
  navigatorRef && 'mediaSession' in navigatorRef,
);

const registerMediaSession = ({ track, isPlaying, onPlay, onPause, onSeekBackward, onSeekForward }, navigatorRef = typeof navigator === 'undefined' ? null : navigator) => {
  if (!canUseMediaSession(navigatorRef)) return false;

  const mediaSession = navigatorRef.mediaSession;
  try {
    if (typeof MediaMetadata !== 'undefined' && track) {
      mediaSession.metadata = new MediaMetadata({
        title: track.title || 'Rastyle',
        artist: track.artist || 'Rastyle',
        artwork: track.cover ? [{ src: track.cover }] : [],
      });
    }

    mediaSession.playbackState = isPlaying ? 'playing' : 'paused';
    mediaSession.setActionHandler('play', onPlay || null);
    mediaSession.setActionHandler('pause', onPause || null);
    mediaSession.setActionHandler('seekbackward', onSeekBackward || null);
    mediaSession.setActionHandler('seekforward', onSeekForward || null);
    return true;
  } catch {
    return false;
  }
};

const clearMediaSession = (navigatorRef = typeof navigator === 'undefined' ? null : navigator) => {
  if (!canUseMediaSession(navigatorRef)) return;
  const mediaSession = navigatorRef.mediaSession;
  try {
    ['play', 'pause', 'seekbackward', 'seekforward'].forEach((action) => mediaSession.setActionHandler(action, null));
    mediaSession.metadata = null;
    mediaSession.playbackState = 'none';
  } catch {}
};

const getYouTubeTimes = (player) => {
  try {
    return {
      position: Number(player?.getCurrentTime?.()) || 0,
      duration: Number(player?.getDuration?.()) || 0,
    };
  } catch {
    return { position: 0, duration: 0 };
  }
};

const seekYouTubeBy = (player, seconds) => {
  const { position, duration } = getYouTubeTimes(player);
  const next = Math.max(0, duration ? Math.min(duration, position + seconds) : position + seconds);
  try {
    player?.seekTo?.(next, true);
    return next;
  } catch {
    return position;
  }
};

export { canUseMediaSession, clearMediaSession, getYouTubeTimes, registerMediaSession, seekYouTubeBy };
